import PropTypes        from 'prop-types';
import { addressShape } from './address';


// @todo ADD TESTS
const serviceLocationShape = {
  '@id':     PropTypes.string.isRequired,
  id:        PropTypes.string.isRequired,
  address:   PropTypes.shape(addressShape),
  latitude:  PropTypes.number,
  longitude: PropTypes.number,
};

export { serviceLocationShape };


// WEBPACK FOOTER //
// ./src/domain/serviceLocation.js